// angular
import { Component, input } from '@angular/core';
import { DatePipe, NgOptimizedImage } from '@angular/common';
import { RouterLink } from '@angular/router';
// interface
import { IHelpData } from '@app/+help/shared/interfaces/help-data.interface';
// pipes
import { ImageSourcePipe } from '@app/shared/pipes/image-source.pipe';
import { TranslateDataPipe } from '@app/shared/pipes/translate-data.pipe';

@Component({
  selector: 'pwj-help-card',
  standalone: true,
  imports: [
    NgOptimizedImage,
    RouterLink,
    ImageSourcePipe,
    DatePipe,
    TranslateDataPipe,
  ],
  templateUrl: './help-card.component.html',
  styleUrl: './help-card.component.scss',
})
export class HelpCardComponent {
  // inputs
  helpCardData = input.required<IHelpData>();
}
